<template>
	<div class="page-in">
		<van-nav-bar
		  :title="$t('活动中心')"
		  fixed
		  placeholder
		  z-index="99"
		  :border="false"
		  v-if="isMobileFlag"
		/>
		<div class="inside-page">
			<div class="layui-container" >
				<div class="a-banner">
					<template v-if="isMobileFlag">
						<img v-if="this.$t('active_m_url') != 'active_m_url'" :href="$t('active_m_url')" alt="" />
						<img src="@/assets/images/a-banner-m.jpg" alt="" />
					</template>
					<template v-else>
						<img v-if="this.$t('active_pic_url') != 'active_pic_url'" :href="$t('active_pic_url')" alt="" />
						<img src="@/assets/images/a-banner-pc.jpg" alt="" />
					</template>
				</div>
				<div class="activity-banner" v-if="false">
					<img src="@/assets/images/AXkxoP.png" class="activity-abs" alt="" />
					<div class="activity-grid">
						<div class="activity-title">
							{{$t('活动宣传语言')}}
						</div>
						<div class="at-search">
							<div class="flex-col">
								<el-input :placeholder="$t('请输入兑换码')" v-model="cdk"></el-input>
							</div>
							<button class="layui-btn layui-btn-normal" @click="exChange">
								{{$t('兑换')}}
							</button>
						</div>
					</div>
				</div>
				<template v-if="this.activity.length > 0">
					<el-row :gutter="isMobileFlag?10:20" class="activity-row">
						<el-col :xs="12" :sm="12" :md="8" :lg="6" v-for="(item,index) in activity" :key="index">
							<div class="activity-item" @click="getDetailNotice(item.id)">
								<div class="activity-item-img">
									<el-image :src="item.thumb" lazy></el-image>
								</div>
								<div class="activity-title">{{item.title}}</div>
							</div>
						</el-col>
						<el-col :xs="12" :sm="12" :md="8" :lg="6" v-if="activity.length === 0">
							<div class="activity-item">
								<div class="activity-item-img">
									<div class="activity-empty">
										<img src="@/assets/images/activity-squce.png" alt="" />
										<div class="empty-label">{{$t('敬请期待')}}</div>
									</div>
								</div>
								<div class="activity-title"></div>
							</div>
						</el-col>
					</el-row>
				</template>
				<empty v-else></empty>
			</div>
		</div>
		<activityDetail :details="detailData" ref="activityPopup"></activityDetail>	
		<Foot :active="3" v-if="isMobileFlag"/>
	</div>
</template>
<script>
	import Foot from "@/components/Foot.vue";
	import empty from "@/components/empty.vue";
	import Cooperation from '../Home/components/Cooperation.vue'
	import activityDetail from './components/activityDetail.vue'
	import {index_notice_list_api,index_notice_details_api} from '@/api/index'
	import {coupons_exchange_api} from "@/api/user"
	export default {
		components:{
			Foot,
			Cooperation,
			activityDetail,
			empty
		},
		data() {
			return {
				cdk:'',
				activity:[],
				detailData:null
			};
		},
		methods:{
			async exChange(){
				if (this.cdk == "") {
					this.errorTips("请输入兑换码");
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				let param = {
					code : this.cdk
				};
				const res = await coupons_exchange_api(param);
				if (res && res.data.code == 1) {
					loading.close();
					this.successTips(res.data.msg)
					this.cdk = ""
				}
				else if (res && res.data.code == -1) {
					this.$helper.rm("tokenInfo");
					this.$helper.rm("userInfo");
					this.$store.commit("$vuexSetLoginState", false);
					this.$store.commit("$vuexUserInfo", null);
					this.goUrl('/login');
					loading.close();
				}
				else{
					this.cdk = ""
					this.errorTips(res.data.msg)
					loading.close();
				}
			},
			async getNotice(typeid) {
				const loading = this.$loading({
				  lock: true,
				  text: '',
				  spinner: 'loader',
				  background: 'rgba(255, 255, 255, 0.3)'
				});
				let param = {
					type : typeid
				};
				const res = await index_notice_list_api(param);
				if (res && res.data.code == 1) {
					this.activity = res.data.data
					loading.close();
				}
			},
			async getDetailNotice(aid) {
				let param = {
					id: aid,
				};
				const loading = this.$loading({
				  lock: true,
				  text: '',
				  spinner: 'loader',
				  background: 'rgba(255, 255, 255, 0.3)'
				});
			  const res = await index_notice_details_api(param);
			  if (res && res.data.code == 1) {
				this.detailData = res.data.data
				this.$refs.activityPopup.show = true
				loading.close();
			  }
			},
		},
		mounted() {
			this.getNotice(3);
		}
	}
</script>
